// extracted by mini-css-extract-plugin
module.exports = {"test":"UI_test__x5scQ"};